import React from 'react';
import { reportError } from '../portal/devlog';

/**
 * Catches render-time crashes so a visitor sees a plain apology instead of a
 * blank white page, and so the webmaster sees the crash in the Dev logs tab.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { crashed: false };
  }

  static getDerivedStateFromError() {
    return { crashed: true };
  }

  componentDidCatch(error, info) {
    reportError(error && error.message ? error.message : 'React render error', {
      stack: error && error.stack ? String(error.stack).slice(0, 800) : undefined,
      component: info && info.componentStack ? String(info.componentStack).slice(0, 400) : undefined,
    });
  }

  render() {
    if (!this.state.crashed) {
      return this.props.children;
    }

    return (
      <div
        style={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '48px 20px',
          textAlign: 'center',
          fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
          color: '#0f172a',
        }}
      >
        <div style={{ maxWidth: 460 }}>
          <h1 style={{ fontSize: 26, fontWeight: 900, margin: '0 0 10px' }}>Something went wrong</h1>
          <p style={{ color: '#6b7280', lineHeight: 1.6, margin: '0 0 20px' }}>
            Sorry about that — the page hit an unexpected error and it has been reported automatically.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              background: '#055907',
              color: '#fff',
              border: 0,
              borderRadius: 12,
              padding: '14px 24px',
              fontWeight: 800,
              fontSize: '1rem',
              cursor: 'pointer',
            }}
          >
            Reload the page
          </button>
        </div>
      </div>
    );
  }
}
